import { useCallback, useEffect, useRef, useState } from 'react';
import useDebouncedCallback from './useDebouncedCallback';
import useMediaQuery from './useMediaQuery';

const useProductDetailsScroll = () => {
  const isMobile = useMediaQuery(1024);
  const ctaContainerRef = useRef<HTMLDivElement>(null);
  const [isCtaContainerAboveViewport, setIsCtaContainerAboveViewport] =
    useState(false);

  const handleScroll = useCallback(() => {
    if (ctaContainerRef.current) {
      const ctaContainerRect = ctaContainerRef.current.getBoundingClientRect();
      setIsCtaContainerAboveViewport(ctaContainerRect.bottom < 0);
    }
  }, []);
  const debouncedHandleScroll = useDebouncedCallback(handleScroll, 50);

  useEffect(() => {
    if (isMobile) {
      window.addEventListener('scroll', debouncedHandleScroll);
      debouncedHandleScroll();
    }

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, [isMobile, debouncedHandleScroll]);

  return {
    ctaContainerRef,
    isCtaContainerAboveViewport,
  };
};

export default useProductDetailsScroll;
